import { render, staticRenderFns } from "./_userProfile.vue?vue&type=template&id=bf32cea2&scoped=true&"
import script from "./_userProfile.vue?vue&type=script&lang=js&"
export * from "./_userProfile.vue?vue&type=script&lang=js&"
import style0 from "./_userProfile.vue?vue&type=style&index=0&id=bf32cea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf32cea2",
  null
  
)

export default component.exports